<script>
   import AgGrid from "@budibase/svelte-ag-grid";
   import "ag-grid-community/styles/ag-grid.css";
   import "ag-grid-community/styles/ag-theme-alpine-dark.css";

   import FbdClassSelector from "./fbdClassSelector";
   import FbdClassTimeReadout from "./fbdClassTimeReadout";

   // Student preview data provided but currently unused
   export let tableTitle, classesData, innerColumnDefs, previewData;

   const gridTitleOptions = {
      headerName: "Class Title",
      field: "class_name",
      cellRenderer: FbdClassSelector
   };

   const gridTimestampOptions = {
      headerName: "Class Created At",
      field: "createdAt",
      resizable: false,
      cellRenderer: FbdClassTimeReadout
   };

   const gridOptions = {
      defaultColDef: {
         flex: 1,
         minWidth: 150,
         filter: true,
         sortable: true,
         editable: false,
         suppressMovable: true,
         resizable: true,
      },
      suppressFieldDotNotation: true,
      tooltipShowDelay: 1500,
      rowSelection: "multiple",
      sideBar: {
         position: 'left',
         toolPanels: ['columns']
      }
   };
   // Not available in this AG Grid wrapper...?
   // tooltipHideDelay: 2000,
   // tooltipInteraction: true,

   const myColumnDefs = [gridTitleOptions];
   for(let inner of innerColumnDefs) {
      myColumnDefs.push(inner);
   }

   myColumnDefs.push(gridTimestampOptions);
</script>


<h2>{tableTitle}</h2>
{#if classesData}
    <AgGrid bind:data={classesData} columnDefs={myColumnDefs} options={gridOptions} />
{:else}
    <h3>One Moment...</h3>
{/if}
<br>